
    <button (click)="isVisible = !isVisible"
            type="button"
            class="mat-icon-button cdk-focused cdk-mouse-focused" mat-icon-button
            matRippleCentered="true"
            matRipple>
      <mat-icon>{{isVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
    </button>
  